import { YACHT_STATUS } from '@/shared/constants/yacht-status.constant';

export const getYachtStatus = (isInProduction: boolean, isDelivered: boolean): YACHT_STATUS => {
	if (isInProduction) return YACHT_STATUS.InProduction;
	if (isDelivered) return YACHT_STATUS.Delivered;

	return YACHT_STATUS.PreDelivery;
};
